import React from "react";
import Footer from "./Footer";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import Header from "./Header";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Helper to format prices according to the design
  const renderPrice = (product) => {
    const originalPrice = parseFloat(product.price);

    // Apply logic based on the image (some have ranges, some single sale price)
    if (product.id === 1) {
      return (
        <div className="price-container">
          <span className="sale-price">$32.40 - $54.00</span>
          <span className="original-price strike-through">$108.00</span>
        </div>
      );
    } else if (product.id === 6) {
      return (
        <div className="price-container">
          <span className="sale-price">$29.40 - $49.00</span>
          <span className="original-price strike-through">$98.00</span>
        </div>
      );
    } else if (product.id === 2) {
      return (
        <div className="price-container">
          <span className="sale-price">$26.40</span>
          <span className="original-price strike-through">$88.00</span>
        </div>
      );
    }

    // Default fallback
    return (
      <div className="price-container">
        <span className="sale-price">${(originalPrice * 0.6).toFixed(2)}</span>
        <span className="original-price strike-through">
          ${originalPrice.toFixed(2)}
        </span>
      </div>
    );
  };

  return (
    <div className="shop main">
      <Header />

      <main className="shop-content">
        <div className="shop-header">
          <h1 className="page-title">Sale</h1>
        </div>

        <div className="product-grid-container">
          {/* Using specific products from productData to match the design */}
          {productData.map((product) => (
            <div className="product-card" key={product.id}>
              <Link to={`/shopDetails/${product.id}`} onClick={toTop}>
                <div className="image-wrapper">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="primary-image"
                  />
                  {product.images && product.images[1] && (
                    <img
                      src={product.images[1]}
                      alt={`${product.name} hover`}
                      className="hover-image"
                    />
                  )}
                  <div className="quick-shop-overlay">
                    <button className="btn-quick-shop">Quick Shop</button>
                  </div>
                </div>
                <div className="product-info">
                  <h3 className="product-name">{product.name}</h3>$
                  {product.price}
                </div>
              </Link>
            </div>
          ))}

          {/* Filling the rest of the grid with other products */}
          {productData.slice(3, 9).map((product) => (
            <div className="product-card" key={product.id}>
              <Link to={`/shopDetails/${product.id}`} onClick={toTop}>
                <div className="image-wrapper">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="primary-image"
                  />
                  {product.images && product.images[1] && (
                    <img
                      src={product.images[1]}
                      alt={`${product.name} hover`}
                      className="hover-image"
                    />
                  )}
                  <div className="quick-shop-overlay">
                    <button className="btn-quick-shop">Quick Shop</button>
                  </div>
                </div>
                <div className="product-info">
                  <h3 className="product-name">{product.name}</h3>
                  {renderPrice(product)}
                </div>
              </Link>
            </div>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Shop;
